<script >
import { ref, computed, onMounted } from 'vue-demi';
import { useRateMethod, useCommonMethod } from '../../../../common/utils/index';
import { useFego } from '../../../../common/utils/useFego';
import { useRateClsByApp } from '../../../../common/utils/rateByApp';
import { typeMapApiName, getIncreaseTag } from '../../../../common/utils/increase';
const __sfc_main = {};
__sfc_main.props = ['followApp', 'defaultRateCol', 'rateLang', 'name', 'newCode', 'ccy', 'flags', 'increaseType', 'titleSize', 'borderColor', 'bgColor'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    useCommonApi
  } = require('@fegobull/webapi').use;

  /** props */
  const props = __props;

  /** ref */
  const increase = ref('---');

  /** common method */
  const {
    isRender
  } = useFego();
  const {
    jumpToFund,
    splitFlag
  } = useCommonMethod();
  const {
    getRateClass,
    getRateSymbol
  } = useRateMethod();
  const rateColorCls = useRateClsByApp(props.followApp, props.defaultRateCol);
  const style4Obj = computed(() => {
    return {
      backgroundColor: props.bgColor,
      borderColor: props.borderColor
    };
  });
  const flagList = computed(() => {
    return splitFlag(props.flags);
  });

  /** 请求数据 */
  const fetchFundRate = async () => {
    if (!isRender.value) {
      return;
    }
    try {
      const apiRequest = useCommonApi('fund-card-big-sw');
      increase.value = await apiRequest.get(typeMapApiName[props.increaseType], {
        code: props.newCode
      });
    } catch (err) {
      console.error(err);
    }
  };
  onMounted(() => {
    fetchFundRate();
  });
  return {
    getIncreaseTag,
    props,
    increase,
    jumpToFund,
    getRateClass,
    getRateSymbol,
    rateColorCls,
    style4Obj,
    flagList
  };
};
export default __sfc_main;
</script>
<template>
    <div class="fund-small-card-item bgClass" :class="[rateColorCls, `local-${props.rateLang}`]" :style="style4Obj">
        <!-- 类型4 -->
        <div class="type-1 type-4" @click="jumpToFund($event, props.newCode)">
            <h5>
                <strong v-if="!flagList.length" class="market">
                    {{ props.ccy }}
                </strong>
                <span>{{ props.name }}</span>
            </h5>
            <ul v-if="flagList.length" class="flagList">
                <li>{{ props.ccy }}</li>
                <li v-for="(item, index) in flagList" :key="'flag_' + index" class="tag">
                    {{ item }}
                </li>
            </ul>
            <div class="gain">
                <!-- <p class="data" :class="{
                    'green': isFall(increaseHkd)
                }"> -->
                <p class="data" :class="[getRateClass(increase)]">{{ getRateSymbol(increase) }}{{ increase }}</p>

                <span class="des">
                    {{ getIncreaseTag(props.increaseType, props.rateLang) }}
                </span>
            </div>
            <div class="arrow"></div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import './index.less';
</style>
